import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';

function StaticTextBlurb(props) {
  const {
    schema: { content },
    value,
  } = props;

  const sanitizedHTML = useMemo(() => {
    let _content = content;
    if (content.includes('$StaticTextBlurbValue')) {
      _content = content.replace('$StaticTextBlurbValue', value);
    }

    return { __html: DOMPurify.sanitize(_content) };
  }, [content, value]);

  return <div dangerouslySetInnerHTML={sanitizedHTML} />;
}

export default StaticTextBlurb;
